import React from 'react'
import { QRCode } from 'antd'
import Foot from './Foot'
import styles from './WebHome.module.css'

const WECHAT_URL = 'https://work.weixin.qq.com/ca/cawcde64d15ad70e2f'

function WebHome() {
    return (
        <div className={styles.page}>
            <header
                className={styles.hero}
                style={{
                    backgroundImage:
                        'linear-gradient(160deg, rgba(12, 31, 36, 0.55) 0%, rgba(12, 31, 36, 0.78) 45%, rgba(12, 31, 36, 0.92) 100%), url(/img/home/hero-bg.png)',
                }}
            >
                <div className={styles.heroInner}>
                    <h1 className={styles.brand}>伯纳思科技</h1>
                    <p className={styles.tagline}>系统解决方案供应商</p>
                    
                </div>
            </header>

            <section className={`${styles.section} ${styles.sectionAlt}`}>
                <div className={styles.sectionNarrow}>
                    <p className={styles.kicker}>Vision</p>
                    <h2 className={styles.title}>愿景</h2>
                    <p className={styles.lede}>
                        形成「网络、数据、智能」全要素信息化体系，成为系统软件产业的重要力量，为推动中国信息现代化、助力经济腾飞贡献更大力量。
                    </p>
                </div>
            </section>

            <section className={styles.section}>
                <div className={styles.sectionNarrow}>
                    <p className={styles.kicker}>Mission</p>
                    <h2 className={styles.title}>使命</h2>
                    <p className={styles.lede}>
                        为政府和企业构建可用、好用的信息系统，让组织插上信息技术的翅膀。
                    </p>
                </div>
            </section>

            <section className={`${styles.section} ${styles.sectionAlt}`}>
                <div className={styles.sectionWide}>
                    <p className={styles.kicker}>About</p>
                    <h2 className={styles.title}>公司介绍</h2>
                    <p className={styles.body}>
                        湖北伯纳思网络科技有限公司于2002年创立，为企业提供系统开发与定制开发服务。。
                    </p>
                    <p className={styles.body}>
                        近年来，伯纳思聚焦主业、有进有退、同心多元，依托国家科技创新与独立自主的政策环境，优化升级信息产业，构建适合政府和企业的信息系统，以稳定的技术服务赢得客户口碑。
                    </p>
                    <p className={styles.body}>
                        依托三峡数据中心等区域数字基础设施，伯纳思持续深耕政企数字化，精心打造「旅当家」等企业管理软件，助力客户实现管理现代化与数字化转型。
                    </p>
                </div>
            </section>

            <section className={styles.section}>
                <div className={styles.sectionNarrow}>
                    <p className={styles.kicker}>History</p>
                    <h2 className={styles.title}>发展历程</h2>
                    <ul className={styles.timeline}>
                        <li className={styles.timelineItem}>
                            <span className={styles.year}>1998</span>
                            <p className={styles.event}>
                                前身沿革起步，扎根本地信息化服务。
                            </p>
                        </li>
                        <li className={styles.timelineItem}>
                            <span className={styles.year}>2002</span>
                            <p className={styles.event}>
                                持续为政府与企业提供系统开发与技术服务。
                            </p>
                        </li>
                        <li className={styles.timelineItem}>
                            <span className={styles.year}>2017</span>
                            <p className={styles.event}>
                               湖北伯纳思网络科技有限公司正式成立，开启新阶段发展。
                            </p>
                        </li>
                        <li className={styles.timelineItem}>
                            <span className={styles.year}>近年</span>
                            <p className={styles.event}>
                                聚焦政企系统软件，依托三峡数据中心等资源，打造数字化产品与服务。
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className={`${styles.section} ${styles.sectionInk}`}>
                <div className={styles.sectionWide}>
                    <p className={styles.kicker}>Contact</p>
                    <h2 className={styles.title}>联系我们</h2>
                    <div className={styles.contactPanel}>
                        <div className={styles.contactActions}>
                            <p className={styles.contactHint}>
                                电脑端可打开企业微信客服；手机可扫码添加微信咨询。
                            </p>
                            <button
                                type="button"
                                className={styles.wechatBtn}
                                onClick={() => {
                                    window.open(WECHAT_URL)
                                }}
                            >
                                微信客服
                            </button>
                        </div>
                        <div className={styles.qrBlock}>
                            <span className={styles.qrLabel}>手机扫码添加微信</span>
                            <div className={styles.qrWrap}>
                                <QRCode value={WECHAT_URL} size={140} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Foot />
        </div>
    )
}

export default WebHome
